import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ExecutivesContext = createContext({ executives: [], execMap: {}, refresh: () => {} });

export function ExecutivesProvider({ children }) {
  const [executives, setExecutives] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/executives");
      setExecutives(data);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const execMap = executives.reduce((acc, e) => {
    acc[e.username] = e.name;
    return acc;
  }, {});

  const uniqueExecutives = Object.values(
    executives.reduce((acc, e) => {
      acc[e.username] = e;
      return acc;
    }, {})
  );

  return (
    <ExecutivesContext.Provider value={{ executives: uniqueExecutives, execMap, refresh }}>
      {children}
    </ExecutivesContext.Provider>
  );
}

export const useExecutives = () => useContext(ExecutivesContext);
